<template>
  <div>
    <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
      <v-toolbar color="#37474F" dark>
        <v-toolbar-title>쿠폰을 발행합니다.</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="blue-grey lighten-2" small fab v-bind="attrs" v-on="on">
              <v-icon color="blue-grey darken-1">mdi-help</v-icon>
            </v-btn>
          </template>
          <span>싱글 타입 쿠폰발행에는 다소 시간이 소요됩니다. 한번에 최대 20만개까지만 만들어주세요.</span>
        </v-tooltip>
      </v-toolbar>

      <v-list>
        <!-- 쿠폰 타입 -->
        <v-list-item>
          <span style="width:160px"><v-card-title class="font-weight-bold">쿠폰 타입</v-card-title></span>
          <v-select
            v-model="selectedCouponType"
            :items="couponTypes"
            item-text="name"
            item-value="value"
            label="타입설정"
            outlined
            hide-details
            @change="onCouponTypeChange"
          ></v-select>
        </v-list-item>
        <v-divider/>

        <!-- 발행 갯수 (싱글 전용) -->
        <v-list-item v-if="selectedCouponType === 'single'">
          <span style="width:160px"><v-card-title class="font-weight-bold">발행갯수</v-card-title></span>
          <v-text-field label="발행할 쿠폰 수 (최대 200,000)" v-model="couponCount" type="number"></v-text-field>
        </v-list-item>
        <v-divider/>

        <!-- 쿠폰 설명 -->
        <v-list-item>
          <span style="width:160px"><v-card-title class="font-weight-bold">쿠폰 설명</v-card-title></span>
          <v-text-field label="쿠폰에 대한 가벼운 메모를 남기세요." v-model="couponMessage"></v-text-field>
        </v-list-item>

        <!-- 종료 날짜 -->
        <v-divider/>
        <v-list-item>
          <span style="width:140px"><v-card-title class="font-weight-bold">종료 날짜</v-card-title></span>
          <span style="width:200px">
            <v-menu v-model="date_picker_2" :close-on-content-click="false" max-width="290">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field :value="date_end" clearable label="종료날짜 (디폴트는 석달 뒤)" readonly v-bind="attrs" v-on="on" @click:clear="date_end = null"></v-text-field>
              </template>
              <v-date-picker v-model="date_end" @change="date_picker_2 = false"></v-date-picker>
            </v-menu>
          </span>
        </v-list-item>

        <!-- 아이템 -->
        <v-divider/>
        <template v-for="(item, index) in selected_itemList">
          <v-list-item :key="index + 1" class="mt-4">
            <span style="width:160px"><v-card-title class="font-weight-bold">아이템 {{ index + 1 }}</v-card-title></span>
            <span style="width:140px">
              <v-select
                v-model="selected_itemList[index]"
                :items="itemInfoList"
                item-text="name"
                item-value="key"
                label="타입설정"
                @change="Refresh_ItemInfo"
                outlined
                hide-details
              ></v-select>
            </span>
            <span style="width:20px"/>
            <span style="width:120px">
              <v-text-field label="지급 수량" v-model="selected_itemList_count[index]" type="number"></v-text-field>
            </span>
            <span style="width:20px"/>
            <span v-if="(selected_itemList.length - 1) !== index">
              <v-btn elevation="2" icon outlined @click="OnRemoveItem(index)">
                <v-icon dark>mdi-close</v-icon>
              </v-btn>
            </span>
          </v-list-item>
        </template>

        <v-divider class="mt-4"/>
        <v-list-item class="mt-4">
          <v-spacer></v-spacer>
          <v-btn width="120px" color="lime accent-3" @click="OnRegist_Coupon" :loading="loading_dialog">쿠폰 생성하기</v-btn>
          <v-spacer></v-spacer>
        </v-list-item>
      </v-list>
    </v-card>

    <!-- 로딩 다이얼로그 -->
    <v-dialog v-model="loading_dialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          쿠폰 생성중입니다...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- 쿠폰 발급 이력 -->
    <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
      <v-toolbar color="#37474F" dark>
        <v-toolbar-title>쿠폰 발급 이력</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="ReloadList"><v-icon>mdi-refresh</v-icon></v-btn>
      </v-toolbar>
      <v-list>
        <v-data-table
          :footer-props="{'items-per-page-options': [20, 50, -1]}"
          :headers="headers"
          :items="coupon_history"
          :loading="loadingData"
        >
          <template v-slot:item="row">
            <tr>
              <td>{{ row.item.COUPON_EXP }}</td>
              <td>{{ row.item.CREATE_USER_ID }}</td>
              <td>{{ row.item.CREATE_DT }}</td>
              <td>{{ row.item.EXPIRE_DT }}</td>
              <td>{{ row.item.COUPON_TYPE }}</td>
              <td>{{ formatCoin(row.item.CREATE_COUNT) }}</td>
              <td>{{ formatCoin(row.item.USED_COUNT) }}</td>
              <td>
                <v-btn class="mx-2" fab dark small color="indigo lighten-3" @click="OnDownloadCouponList(row.item.PID)">
                  <v-icon color="light-blue accent-4">mdi-download</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-list>
    </v-card>
    <div class="py-12"/>
  </div>
</template>

<script>
import moment from 'moment';
import { format, parseISO } from 'date-fns';
import { pnt_factory_coupon } from '../../api/pnt_factory';

export default {
  name: 'PntFactoryGameCoupon',
  data: () => ({
    loadingData: false,
    loading_dialog: false,
    selectedCouponType: 'single',
    couponCount: 1,
    couponMessage: '이벤트 쿠폰 발급',
    date_end: '',
    date_picker_2: false,
    couponTypes: [
      { name: '싱글타입 (1회성 쿠폰)', value: 'single' },
      { name: '전체타입 (모든 유저 중복없이 사용가능)', value: 'all' },
    ],
    itemInfoList: [
      { name: '보석', key: '1000001' },
    ],
    selected_itemList: [],
    selected_itemList_count: [],
    coupon_history: [],
    headers: [
      { text: '쿠폰 Info', value: 'title' },
      { text: '관리자', value: 'admin' },
      { text: '등록 일자', value: 'regist_date' },
      { text: '만료 일자', value: 'expire_date' },
      { text: '쿠폰 타입', value: 'target' },
      { text: '발급 갯수', value: 'coupon_count' },
      { text: '사용 갯수', value: 'use_count' },
      { text: '다운로드', value: 'download' },
    ],
  }),
  created() {
    this.date_end = moment().add(3, 'M').format('YYYY-MM-DD');
    this.Refresh_ItemInfo();
    this.ReloadList();
  },
  methods: {
    onCouponTypeChange() {
      this.Refresh_ItemInfo();
    },
    Refresh_ItemInfo() {
      const tempItems = [];
      const tempCounts = [];
      for (let i = 0; i < this.selected_itemList.length; i++) {
        if (this.selected_itemList[i] != null) {
          tempItems.push(this.selected_itemList[i]);
          tempCounts.push(this.selected_itemList_count[i] ?? 0);
        }
      }
      this.selected_itemList = [];
      this.selected_itemList_count = [];
      for (let i = 0; i < tempItems.length; i++) {
        this.selected_itemList.push(tempItems[i]);
        this.selected_itemList_count.push(tempCounts[i]);
      }
      this.selected_itemList.length = tempItems.length + 1;
      this.selected_itemList_count.length = tempItems.length + 1;
    },
    OnRemoveItem(index) {
      this.selected_itemList[index] = undefined;
      this.Refresh_ItemInfo();
    },
    Make_ItemResultInfo() {
      const result = [];
      for (let i = 0; i < this.selected_itemList.length; i++) {
        if (this.selected_itemList[i] !== undefined) {
          result.push({ key: this.selected_itemList[i], count: this.selected_itemList_count[i] || 0 });
        }
      }
      return result;
    },
    async ReloadList() {
      this.loadingData = true;
      try {
        const body = await pnt_factory_coupon.get_recent_couponlist();
        this.coupon_history = body?.coupon_list || [];
      } catch (e) {
        console.error('[PntFactory Coupon] get_recent_couponlist', e);
      } finally {
        this.loadingData = false;
      }
    },
    async OnRegist_Coupon() {
      const coupon_item = this.Make_ItemResultInfo();
      if (!coupon_item.length || !this.couponMessage) {
        alert('필수 정보 입력필요!');
        return;
      }
      let count = Number(this.couponCount);
      if (count > 200000) count = 200000;
      if (this.selectedCouponType === 'all') count = 1;
      const expire_dt = this.date_end + ' 23:59:59';
      const coupon_type = this.selectedCouponType;
      const custom_coupon_id = null;
      this.loading_dialog = true;
      try {
        await pnt_factory_coupon.create_coupon({ coupon_type, coupon_item, expire_dt, count, custom_coupon_id });
        alert('완료!');
        await this.ReloadList();
      } catch (e) {
        console.error('[PntFactory Coupon] create_coupon', e);
        alert('쿠폰 생성 실패');
      } finally {
        this.loading_dialog = false;
      }
    },
    async OnDownloadCouponList(coupon_pid) {
      this.loading_dialog = true;
      try {
        const body = await pnt_factory_coupon.get_coupon_list({ coupon_pid });
        const coupon_list = body?.coupon_list || [];
        let dataContainer = coupon_list.map(c => c.COUPON_ID).join('\n');
        const blob = new Blob([dataContainer], { type: 'octet/stream' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'PntFactory_CouponFile.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (e) {
        console.error('[PntFactory Coupon] get_coupon_list', e);
        alert('다운로드 실패');
      } finally {
        this.loading_dialog = false;
      }
    },
    formatCoin(v) {
      const n = Number(v);
      return Number.isNaN(n) ? '0' : n.toLocaleString();
    },
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .v-list-item { flex-wrap: wrap; }
  .v-list-item > span { width: 100% !important; }
  .v-data-table { overflow-x: auto; }
}
</style>
